/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.


import classnames from 'classnames'
import moment from 'moment'

import DropDown from 'components/DropDown'
import IconSVG from 'svg-inline-react'
import TimeSelectorDropdown from './TimeSelectorDropdown'

import PropTypes from 'prop-types'

import 'styles/components/TimeSelectorButton'

export default React.createClass({
  mixins: [require('react-onclickoutside')],

  propTypes: {
    onSetRange: PropTypes.func.isRequired,
    selectedDateRange: PropTypes.object
  },

  getInitialState() {
    return {
      showTimeRangeDropdown: false
    }
  },

  formatDate(date) {
    const todayOrYesterday = date.calendar(null, { sameDay: '[Today]', lastDay: '[Yesterday]' })
    if ((todayOrYesterday === 'Today') || (todayOrYesterday === 'Yesterday')) { return todayOrYesterday }

    return date.format('MMMM D')
  },

  getRangeText() {
    if (this.props.selectedDateRange) {
      return `${ this.formatDate(this.props.selectedDateRange.start) } - ${ this.formatDate(this.props.selectedDateRange.end) }`
    }
  },

  render() {
    return (
      <div className="TimeSelectorButton">
        <button
          ref="timeButton"
          className={classnames('main-button', { selected: this.state.showTimeRangeDropdown })}
          onClick={this.handleOnClick}>
          <div>
            {this.getRangeText()}
          </div>
          <IconSVG src={require('!svg-inline?removeTags=true!images/icons/caret-icon.svg')} />
        </button>
        {this.state.showTimeRangeDropdown ?
          <div>
            <DropDown
              className="time-selector-dropdown"
              onClickOutside={this.handleClickOutside}>
              <TimeSelectorDropdown {...this.props} />
            </DropDown>
          </div> : undefined}
      </div>
    )
  },

  handleClickOutside() {
    return this.setState({ showTimeRangeDropdown: false })
  },

  handleOnClick() {
    return this.setState({ showTimeRangeDropdown: !this.state.showTimeRangeDropdown })
  }
})



// WEBPACK FOOTER //
// ./src/scripts/components/shared/TimeSelectorButton.js